import { AxiosResponse } from "axios";
import { useEffect, useMemo, useState } from "react";
import { IColumnConfigConditional } from "../../../../models";
import { IAxiosError } from "../../../../utils";
import { errorDataLoading } from "../../appStates/appStates";
import { AvisSimpleTable, IColumnConfig } from "./";

interface IAvisDataTableProps<T> {
  columnMetadata: IColumnConfig[];
  columnWidths?: number[];
  conditionalFormatting?: IColumnConfigConditional<T>[];
  setError: React.Dispatch<React.SetStateAction<IAxiosError | undefined>>;
  getApiData: () => Promise<AxiosResponse<T[], any>>;
  onDataLoaded?: (data: T[]) => void;
}
export function AvisDataTable<T extends object>(
  props: Readonly<IAvisDataTableProps<T>>,
) {
  const {
    columnWidths,
    columnMetadata,
    conditionalFormatting,
    setError,
    getApiData,
    onDataLoaded,
  } = props;

  const [tableData, setTableData] = useState<T[]>();
  const [isGridLoading, setIsGridLoading] = useState<boolean>(true);

  const getGridData = useMemo(() => {
    if (errorDataLoading.value) return;

    setIsGridLoading(true);
    getApiData()
      .then((res) => {
        setTableData(res.data);
        if (onDataLoaded) onDataLoaded(res.data);
      })
      .catch(setError)
      .finally(() => {
        setIsGridLoading(false);
      });
  }, [setTableData, getApiData, setError, onDataLoaded]);

  useEffect(() => {
    getGridData;
  }, [getGridData]);

  return (
    <div className="avis-data-table-container">
      <AvisSimpleTable<T>
        data={tableData}
        loading={isGridLoading}
        columnMetadata={columnMetadata}
        columnWidths={columnWidths}
        conditionalFormatting={conditionalFormatting}
      />
    </div>
  );
}
